import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';

/**
 * NavRenderer - Renders navigation items with proper layout and conditional rendering
 *
 * @param {object} props - Props.
 * @param {React.Node} props.navItems - Main navigation items.
 * @param {React.Node} props.filterItems - Filter items component.
 * @param {React.Node} props.settingsButton - Settings button component.
 * @param {React.Node} props.additionalNavItems - Additional navigation items.
 * @param {React.Node} props.roundButtons - Round buttons component.
 * @param {Function} props.isFiltersVisibleHandler - Handler for filter visibility toggle.
 * @param {boolean} props.withScrollableFilter - Whether to use scrollable filter layout.
 * @param {boolean} props.useRefinedFilter - Whether to use refined filter.
 * @param {boolean} props.areFilterOptionsVisible - Whether filter options are visible.
 * @param {boolean} props.resetFilterBtnStyles - Whether to reset filter button styles.
 * @param {Function} props.setResetFilterBtnStyles - Function to set reset filter button styles.
 * @returns {React.Element} Component.
 */
export const NavRenderer = ({
    navItems,
    filterItems,
    settingsButton,
    additionalNavItems,
    roundButtons,
    isFiltersVisibleHandler,
    withScrollableFilter,
    useRefinedFilter,
    areFilterOptionsVisible
}) => {
    return (
        <>
            {navItems}
            {filterItems &&
                useRefinedFilter &&
                cloneElement(filterItems, {
                    isFiltersVisibleHandler
                })}

            {!!settingsButton && !withScrollableFilter && (
                <div className="stats-leaders-nav__filter-button-wrapper">
                    {settingsButton}
                </div>
            )}

            {!!additionalNavItems && !withScrollableFilter && (
                <div className="stats-leaders-nav__filter-button-wrapper">
                    {additionalNavItems}
                </div>
            )}

            {!!roundButtons &&
                !areFilterOptionsVisible &&
                !withScrollableFilter && (
                    <div className="stats-leaders-nav__round-buttons-wrapper">
                        {roundButtons}
                    </div>
                )}
        </>
    );
};

NavRenderer.propTypes = {
    navItems: PropTypes.node,
    filterItems: PropTypes.node,
    settingsButton: PropTypes.node,
    additionalNavItems: PropTypes.node,
    roundButtons: PropTypes.node,
    isFiltersVisibleHandler: PropTypes.func.isRequired,
    withScrollableFilter: PropTypes.bool,
    useRefinedFilter: PropTypes.bool,
    areFilterOptionsVisible: PropTypes.bool,
    resetFilterBtnStyles: PropTypes.bool,
    setResetFilterBtnStyles: PropTypes.func
};
